"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGES = void 0;
exports.ERROR_MESSAGES = {
    PROXY_EMPTY_RESPONSE: 'proxy_empty_response',
    PROXY_UNAVAILABLE: 'proxy_unavailable',
    AD_UNIT_ID_REQUIRED: 'ad_unit_id_is_required',
};
//# sourceMappingURL=error-messages.js.map